import React from "react";
import "../styles/Footer.css";
import logo from "../assets/img/Logo.png";

const Footer: React.FC = () => {
    return (
        <footer className="custom-footer">
            <div className="container footer-row">
                <div className="footer-col footer-left">
                    <img src={logo} alt="Baldų Sintezė" className="footer-logo-large" />
                </div>

                <div className="footer-col footer-right">
                    <h6 className="contact-title">Kontaktai:</h6>

                    <ul className="contact-list">
                        <li>
                            <i className="fas fa-phone-alt" aria-hidden="true"></i>
                            <a href="tel:+37064370102">+37064370102</a>
                        </li>
                        <li>
                            <i className="fas fa-envelope" aria-hidden="true"></i>
                            <a href="mailto:info@baldusinteze.lt">info@baldusinteze.lt</a>
                        </li>
                        <li>
                            <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
                            <span>Lietuva, Panevėžio m.</span>
                        </li>
                    </ul>

                    <div className="footer-socials">
                        <a
                            href="https://www.facebook.com/profile.php?id=61567350364772"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                            title="Facebook"
                        >
                            <img
                                className="social-img"
                                alt="Facebook"
                                src="https://upload.wikimedia.org/wikipedia/commons/1/1b/Facebook_icon.svg"
                            />
                        </a>

                        <a
                            href="https://www.instagram.com/baldusinteze/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            title="Instagram"
                        >
                            <img
                                className="social-img"
                                alt="Instagram"
                                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
